import './AboutProfessorCard.css'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import AboutProfessorInfoContent from './AboutProfessorInfoContent/AboutProfessorInfoContent'
import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/core';
import { useConfigContext } from '../../../../contexts/ConfigContext/ConfigContextProvider';

export default function AboutProfessorCard({ teachers }) {

   const { jsonTexts } = useConfigContext()
   const texts = jsonTexts?.lessonView?.lessonDetailsCards?.aboutProfessorCard

   const isOneProfessor = teachers.length === 1

   return (
      <article className='ClassDetails-card-container'>
         <div className='ClassDetails-card--row'>
            <h5 className='ClassDetails-card-headline'>{isOneProfessor ? texts?.singularTeacherText : texts?.pluralTeacherText}</h5>
         </div>

         {isOneProfessor
            ? teachers.map(professor => (
               < AboutProfessorInfoContent
                  key={professor._id}
                  about={professor.about}
                  name={professor.name}
                  lastname={professor.lastname}
                  profilePicture={professor.profilePicture}
                  specialty={professor.specialty}
                  />
            ))
            : <Splide aria-label="Profesores del curso" options={{
               rewind: true,
               gap: '1rem',
               width: '100%',
               height: '100%'
            }}>
               {teachers.map(professor => (
                  <SplideSlide >
                     < AboutProfessorInfoContent
                        about={professor.about}
                        name={professor.name}
                        lastname={professor.lastname}
                        profilePicture={professor.profilePicture}
                        specialty={professor.specialty}
                        />
                  </SplideSlide>
               ))}
            </Splide>
         }

      </article>
   )
}
